<template>
  <div class="padded vh100 flex-center">
    <form id="register-view" class="card form form_login padded-xl w500" @submit.prevent="sendForgotMail">
      <div>
        <img src="favicon.png" alt="" style="height: 40px; margin-bottom: 15px;"/>
      </div>
      <h1 class="display-6 mb-4">Wachtwoord vergeten?</h1>
      <transition name="fade">
        <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
      </transition>
      <input-default label="Jouw emailadres" v-model="userEmail" description="Wij mailen jou je wachtwoord"/>
      <div class="button-row">
        <button class="btn btn-primary" type="submit">Stuur mij een mail</button>
      </div>
    </form>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import axios from 'axios'

  import { authHeader } from '../services/auth-header.js';

  export default {
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        userEmail: '',
        returnUrl: '',
        error: ''
      }
    },
    components: {
      InputDefault,
      AlertBar
    },
    methods: {
      sendForgotMail(){

        const data = {
          email: this.userEmail
        }

        this.loading = true

        axios.post(process.env.VUE_APP_ROOT_API+'/forgetPassword', data)
        .then(
          response => {
            console.log(response.data)
            if (response.data.success == false){
              this.msgtext = response.data.error_message
            } else {
              this.msgclass = 'success'
              this.msgtext = 'We hebben je een email verzonden'
            }
          },
          error => {
            console.log(error.data)
            this.msgtext = error,
            this.loading = false
          }
        )
      }
    }
  }
</script>